// src/components/ProgressBar.js
import React from 'react';
import '../styles/LoginSignup.css'; // Importa o CSS específico para o login

const ProgressBar = () => (
  <div className="progress-bar">
    <div className="progress" />
  </div>
);

export default ProgressBar;
